import { STATIC_LAYER_ZINDEX } from './constants/mapZIndexes';

export const mapOptions = {
  center: {
    lat: 39.8283,
    lng: -98.5795,
  }, // geographic center of the contiguous USA
  zoom: 4,
  fullscreenControl: false,
  gestureHandling: 'greedy',
};

// Dynamic layers trailing line
export const layerTrailingLineStyles = {
  geodesic: true,
  strokeColor: '#0a266c', // light mode purples.day_10
  strokeOpacity: 0,
  strokeWeight: 1,
  // strokeOpacity: 0 and use of icons below create the dashed lines look
  icons: [
    {
      icon: {
        fillColor: '#0a266c',
        path: 'M 0, -1 0, 1',
        strokeColor: '#0a266c',
        strokeOpacity: 1,
        strokeWeight: 2,
        scale: 4,
      },
      offset: '0',
      repeat: '20px',
    },
  ],
};

/**
 * Default spatial layer styles
 * @param {Boolean} isActive - is the spatial layer active?
 */
export const layerStyles = isActive => {
  return {
    strokeColor: isActive ? '#ff0015' : '#a08f86',
    strokeOpacity: 0.4,
    strokeWeight: 3,
    fillColor: isActive ? '#ff0015' : 'transparent',
    fillOpacity: isActive ? 0.05 : 0,
    zIndex: STATIC_LAYER_ZINDEX,
  };
};

export const layerHoverStyles = opts => {
  return {
    strokeColor: opts.strokeColor || '#C8C8C8',
    strokeOpacity: opts.strokeOpacity || 1,
    strokeWeight: opts.strokeWeight || 2,
    fillColor: opts.fillColor || '#C8C8C8',
    fillOpacity: 0.15,
    zIndex: STATIC_LAYER_ZINDEX,
  };
};

export const layerActiveStyles = opts => {
  return {
    strokeColor: opts.strokeColor || '#24B3F3',
    strokeOpacity: opts.strokeOpacity || 1,
    strokeWeight: opts.strokeWeight || 2,
    fillColor: 'transparent',
    fillOpacity: 0,
    zIndex: STATIC_LAYER_ZINDEX,
  };
};
